import api, { API_REPORT_TIMEOUT_MS } from "./api";

export const fetchAdminAnalytics = () => api.get("/admin/analytics/");
export const fetchAdminRevenueOverview = () => api.get("/admin/revenue-overview/");
export const fetchAdminSsaOverview = () => api.get("/admin/ssa-overview/");

export const fetchAdminFinancialDashboard = (params = {}) => {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && String(v).trim() !== "") p.set(k, String(v).trim());
  });
  const q = p.toString();
  return api.get(`/admin/financial-dashboard/${q ? `?${q}` : ""}`);
};
export const fetchPlatformSettings = () => api.get("/admin/platform/settings/");
export const updatePlatformSettings = (payload) => api.patch("/admin/platform/settings/", payload);
export const fetchAdminAuditLogs = () => api.get("/admin/audit-logs/");
export const fetchProjectFundLedger = (projectId) => api.get(`/admin/projects/${projectId}/fund-ledger/`);
export const fetchProjectTreasuryReport = (projectId) => api.get(`/admin/projects/${projectId}/treasury-report/`);

export async function downloadDepositsReportCsv() {
  const res = await api.get("/admin/reports/deposits/", {
    responseType: "blob",
    timeout: API_REPORT_TIMEOUT_MS,
  });
  const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "deposits_report.csv";
  a.click();
  window.URL.revokeObjectURL(url);
}

export async function downloadDepositsReportPdf() {
  const res = await api.get("/admin/reports/deposits/pdf/", {
    responseType: "blob",
    timeout: API_REPORT_TIMEOUT_MS,
  });
  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "deposits_report.pdf";
  a.click();
  window.URL.revokeObjectURL(url);
}
